// src/components/ModulePreviewModal.jsx
import React, { useEffect } from 'react';
import GenericModal from './GenericModal';
import '../assets/css/modulePreviewModal.css';
import { FiTarget } from 'react-icons/fi';
import { FaCalendarAlt, FaCheckCircle } from 'react-icons/fa';
import { FaChartLine, FaDumbbell } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

const ModulePreviewModal = ({ module, isOpen, onClose }) => {

    // Fechar ao pressionar Esc
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') onClose();
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEsc);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = 'auto';
        };
    }, [isOpen, onClose]);

    if (!module) return null;

    const getTopicIcon = (topicId) => {
        const icons = {
            1: <FiTarget className="icon" />,
            2: <FaCalendarAlt className="icon" />,
            3: <FaDumbbell className="icon" />,
            4: <FaChartLine className="icon" />
        };
        return icons[topicId] || <FaCalendarAlt className="icon" />;
    };

    return (

        <GenericModal
            isOpen={isOpen}
            onClose={onClose}
            title={module.titulo}
            className="module-preview-modal"
        >
            <>
                <div className="modal-header">
                    <p className="modal-desc">{module.descricao}</p>
                </div>

                <div className="modal-body">
                    <div className="topics-container">
                        {module.topicos.map(topic => (
                            <div className="topic-card" key={topic.id}>
                                <div className="topic-card-header">
                                    <div className="topic-card-icon">
                                        {getTopicIcon(topic.id)}
                                    </div>
                                    <div>
                                        <h3 className="topic-card-title">{topic.titulo}</h3>
                                        <p className="topic-card-desc">{topic.descricao}</p>
                                    </div>
                                </div>
                                <div className="tasks-list">
                                    {topic.tarefas.map(task => (
                                        <div className="task-item" key={task.id}>
                                            <div className="task-icon">
                                                <FaCheckCircle className="icon" />
                                            </div>
                                            <div className="task-info">
                                                <h4 className="task-title">{task.titulo}</h4>
                                                <p className="task-desc">{task.descricao}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="modal-btn btn-close" onClick={onClose}>Fechar</button>
                    <Link to={'como-acessar'} className="modal-btn btn-primary">Começar Módulo</Link>
                </div>
            </>
        </GenericModal>
    );
};

export default ModulePreviewModal;